module.exports = __webpack_public_path__ + "static/media/unidade-icon.98198cac.svg";